import React, { useState, useEffect } from "react";
import Axios from "axios";
import {
  MDBIcon,
  MDBNavbar,
  MDBNavbarNav,
  MDBContainer,
  MDBRow,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBNavItem,
  MDBNavbarBrand,
  MDBNavLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBCol,
  MDBFormInline,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
} from "mdbreact";

import {
  MDBSideNavNav,
  MDBSideNav,
  MDBSideNavLink,
  MDBNavbarToggler,
  MDBBtn,
  MDBCollapse,
} from "mdbreact";
import { Link } from "react-router-dom";

import useWindowDimensions from "./useWindowDimensions";
import ChangePassword from "../Administrator/ChangePassword";
import ChangeProfilePhoto from "../ProfilePhoto/ChangeProfiePhoto";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faBoxesPacking,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";

const NavBarPage = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const { width } = useWindowDimensions();

  const [SideNavRight, setSideNavRight] = useState(false);
  const [sideNavLeft, setSideNavLeft] = useState(false);

  const ToggleSideNavLeft = () => {
    setSideNavLeft(!sideNavLeft);
  };
  const ToggleSideNavRight = () => {
    setSideNavRight(!SideNavRight);
  };
  const useMountEffect = (functionName) => useEffect(functionName, []);

  const [showPreloader, setPreloader] = useState("normal");

  const [isOpen, setOpen] = useState(false);

  const toggleCollapse = () => {
    setOpen(!isOpen);
  };

  const [modalChangeProfilePhoto, showAddEdit] = useState(false);
  const toggleChangeProfilePhoto = () => {
    showAddEdit(!modalChangeProfilePhoto);
  };
  const [modalLogout, showLogoutBox] = useState(false);

  const askLogout = () => {
    showLogoutBox(!modalLogout);
  };

  function confirmLogout() {
    showLogoutBox(!modalLogout);

    Logout();
  }
  function Logout() {
    sessionStorage.removeItem("hash");
    sessionStorage.removeItem("msal.ec");
    sessionStorage.removeItem("msal.in");
    sessionStorage.removeItem("msal.uc");
    sessionStorage.removeItem("Email");
    sessionStorage.removeItem("User");
    sessionStorage.removeItem("accountname");
    window.location.replace(props.deployURL + "/");
  }
  const AdminMenu = () => {
    return (
      <React.Fragment>
        <MDBSideNavLink
          title="Reports"
          to={process.env.PUBLIC_URL + "/reports"}
        >
          <MDBIcon icon="industry"></MDBIcon> Reports
        </MDBSideNavLink>
        <MDBSideNavLink
          title="Administrator"
          to={process.env.PUBLIC_URL + "/administrator"}
        >
          <MDBIcon icon="shield-alt"></MDBIcon> Administrator
        </MDBSideNavLink>
      </React.Fragment>
    );
  };

  const [modalChangePassword, showChangePassword] = useState(false);

  const toggleChangePassword = () => {
    showChangePassword(!modalChangePassword);
  };

  return (
    <React.Fragment>
      <MDBNavbar
        // className="primary-color"
        // dark
        // expand="md"
        // fixed="top"
        className="cloudy-knoxville-gradient"
        color="primary"
        expand="md"
        fixed="top"
        scrolling
      >
        {/* <a href="#!" onClick={ToggleSideNavLeft} className="white-text">
          <MDBIcon icon="bars" size="1x" className="white-text" />
        </a> */}
        <MDBNavbarBrand
          // className="pl-2"
          className="ml-0 pl-0"
        >
          {width <= 770 ? (
            <span
              style={{ fontFamily: "Montserrat" }}
              className="small blue-text p-0 m-0 small"
            >
              <small>NUTECH AUTO CARE CENTER</small>
            </span>
          ) : (
            <strong
              style={{ fontFamily: "Roboto", fontWeight: "700" }}
              className="black-text"
            >
              <h5
                style={{ fontFamily: "Montserrat", fontWeight: "800" }}
                className="display-5 blue-text"
              >
                {" "}
                NUTECH AUTO CARE CENTER
              </h5>
            </strong>
          )}
        </MDBNavbarBrand>

        <MDBNavbarNav right>
          <MDBFormInline>
            <MDBNavItem>
              <MDBNavLink
                className="waves-effect waves-light"
                to={process.env.PUBLIC_URL + "/home"}
              >
                <MDBIcon icon="home" size="2x" className="blue-text" />
              </MDBNavLink>
            </MDBNavItem>

            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <MDBIcon icon="user" size="2x" className="purple-text" />
                </MDBDropdownToggle>
                <MDBDropdownMenu className="primary">
                  <MDBDropdownItem href="#!" onClick={askLogout}>
                    Log out
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
          </MDBFormInline>
        </MDBNavbarNav>
      </MDBNavbar>
      <MDBSideNav
        slim
        fixed
        triggerOpening={sideNavLeft}
        breakWidth={2700}
        className="primary-color"
      >
        <li>
          <div className="logo-wrapper sn-ad-avatar-wrapper">
            <a href="#">
              <img
                alt=""
                src={process.env.PUBLIC_URL + "/logo2.png"}
                className="rounded-circle"
              />
              <span>VMTMS</span>
            </a>
          </div>
        </li>
        <MDBSideNavNav>
          <MDBSideNavLink title="Home" to={process.env.PUBLIC_URL + "/"}>
            <MDBIcon icon="home"></MDBIcon> Home Page
          </MDBSideNavLink>

          <MDBSideNavLink title="About" to={process.env.PUBLIC_URL + "/about"}>
            <MDBIcon icon="question-circle" className="white-text" /> About
            VMTMS
          </MDBSideNavLink>
        </MDBSideNavNav>
      </MDBSideNav>
      <MDBModal backdrop={false} isOpen={modalLogout} toggle={askLogout}>
        <MDBModalHeader className="text-left black-text young-passion-gradient">
          <h6 className="white-text">
            {" "}
            <b>LOGOUT</b>
          </h6>
        </MDBModalHeader>
        <MDBModalBody className="text-center">
          <MDBRow>
            <MDBCol md="12" className="black-text text-center">
              <p></p>
              <p>
                You are about to logout.
                <br /> Any unsaved changes will be discarded.
              </p>
              <p>
                <br />
                Do you really want to logout?
              </p>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol md="12" className="black-text">
              <p className="text-center">
                <MDBBtn color="danger" size="sm" onClick={confirmLogout}>
                  Yes
                </MDBBtn>
                <MDBBtn
                  className="cloudy-knoxville-gradient blue-text"
                  size="sm"
                  onClick={askLogout}
                >
                  No
                </MDBBtn>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBModalBody>
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalChangePassword}
        toggleModal={toggleChangePassword}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="blue-gradient">
            <h6 className="white-text">
              <b>Change Password</b>
            </h6>
          </MDBCardHeader>
          <MDBCardBody>
            <ChangePassword
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              usercode={""}
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleChangePassword}
            />
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleChangePassword} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalChangeProfilePhoto}
        toggleModal={toggleChangeProfilePhoto}
        fullHeight
        position="right"
        size="md"
      >
        <MDBCardHeader className="blue-gradient">
          <h5 className="h5-responsive white-text">
            <b>Upload Profile Photo</b>
          </h5>
        </MDBCardHeader>
        <MDBCardBody>
          <ChangeProfilePhoto
            toggleModal={toggleChangeProfilePhoto}
            code={"newrecord"}
            employeecode={props.employeeCodeGlobal}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            title={"Upload a File"}
          />
        </MDBCardBody>
      </MDBModal>{" "}
    </React.Fragment>
  );
};

export default NavBarPage;
